import RequestDetailsDialog from "./RequestDetailsDialog/RequestDetailsDialog.vue";
import RequestDialog from "./RequestDialog/RequestDialog.vue";
import RequestResponseDialog from "./RequestResponseDialog/RequestResponseDialog";

export default {
	RequestDetailsDialog,
	RequestDialog,
	RequestResponseDialog
};
